import { render, staticRenderFns } from "./InputOnClick.vue?vue&type=template&id=199ebfbf&scoped=true"
import script from "./InputOnClick.vue?vue&type=script&lang=js"
export * from "./InputOnClick.vue?vue&type=script&lang=js"
import style0 from "./InputOnClick.vue?vue&type=style&index=0&id=199ebfbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ebfbf",
  null
  
)

export default component.exports